/**
 * Where the client sends its API calls.
 *
 * Read from a `<meta>` tag rather than baked in at build time, so one bundle
 * works in every environment and switching backends is an edit to `index.html`
 * instead of a rebuild:
 *
 *     <meta name="prompt-relay-api-base" content="https://api.example.com" />
 *
 * Absent or empty means same-origin, which is what the Firebase Hosting rewrite
 * to Cloud Run gives us — no cross-origin requests, so no CORS to configure.
 */

export const API_BASE_META_NAME = "prompt-relay-api-base";

export const GOOGLE_CLIENT_ID_META_NAME = "google-client-id";

export function readApiBaseUrl(document: Document): string {
  const meta = document.querySelector<HTMLMetaElement>(
    `meta[name="${API_BASE_META_NAME}"]`,
  );
  const value = meta?.content.trim() ?? "";

  // A trailing slash would produce "…//api/prompts" once a path is appended.
  return value.replace(/\/+$/, "");
}

/**
 * The OAuth client id Google Identity Services signs in against.
 *
 * Read from the page for the same reason as the API base: one bundle works in
 * every environment. It is *not* a secret — it is published in the HTML by
 * design, and an OAuth client is pinned to its authorised origins rather than
 * to who knows its id.
 */
export function readGoogleClientId(document: Document): string {
  const meta = document.querySelector<HTMLMetaElement>(
    `meta[name="${GOOGLE_CLIENT_ID_META_NAME}"]`,
  );

  return meta?.content.trim() ?? "";
}
